"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableConstants = exports.mineSiteLabelOptions = exports.applicationConstants = exports.CONSTANTS = void 0;
const CONSTANTS = exports.CONSTANTS = {
  GET_MINESITES: 'GET_MINESITES',
  GET_USER_DETAILS: 'GET_USER_DETAILS',
  GET_ROLES_FOR_APP: 'GET_ROLES_FOR_APP',
  REMOVE_ACCESS: 'Remove Access',
  SUCCESS_MSG: 'Access for {displayName} has been removed successfully',
  activity: '/Users/Activities',
  apiBaseUrl: 'https://customer.staging.weir/api/identity/iamservice',
  SEND_INVITATION_STATE: 'Send Invitation State'
};
const applicationConstants = exports.applicationConstants = {
  handleProgressAction: null,
  apiCallInprogressCount: 0
};
const tableConstants = exports.tableConstants = {
  SEARCH_PLACEHOLDER_ONBLUR: 'Search',
  SEARCH_PLACEHOLDER_ONFOCUS: 'Enter min. 3 characters',
  RESULTS_LBL_SINGULAR: 'Result',
  RESULTS_LBL_PLURAL: 'Results',
  NO_RESULTS_LBL: 'No Results',
  NO_RECORDS_FOUND_LBL: 'No Records'
};
const mineSiteLabelOptions = exports.mineSiteLabelOptions = {
  'Mine Site': 'Mine Sites',
  'Company': 'Companies'
};